var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBePart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1111 3.50153C36.8405 -1.16718 29.9167 -1.16718 25.6473 3.50153L22.157 7.31715L18.6668 3.50153C14.3962 -1.16718 7.47238 -1.16718 3.20296 3.50153C-1.06765 8.17024 -1.06765 15.7394 3.20296 20.4069L6.69322 24.2225L22.157 41.1291L37.622 24.2225L41.1123 20.4069C45.3817 15.7394 45.3817 8.17024 41.1111 3.50153Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1111 3.50153C36.8405 -1.16718 29.9167 -1.16718 25.6473 3.50153L22.157 7.31715L18.6668 3.50153C14.3962 -1.16718 7.47238 -1.16718 3.20296 3.50153C-1.06765 8.17024 -1.06765 15.7394 3.20296 20.4069L6.69322 24.2225L22.157 41.1291L37.622 24.2225L41.1123 20.4069C45.3817 15.7394 45.3817 8.17024 41.1111 3.50153Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2069 45.4039L40.7752 29.6888L44.8673 25.2747C46.8519 23.1338 48.0496 20.4652 48.4604 17.6873C50.967 22.2776 50.4127 28.3092 46.798 32.2608L43.3078 36.0764L30.5615 50.0001L26.2069 45.4039Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2069 45.4039L40.7752 29.6888L44.8673 25.2747C46.8519 23.1338 48.0496 20.4652 48.4604 17.6873C50.967 22.2776 50.4127 28.3092 46.798 32.2608L43.3078 36.0764L30.5615 50.0001L26.2069 45.4039Z",
    fill: "#256BE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBePart);
export default __webpack_public_path__ + "static/media/be-part.35dfd191d37b802fe885ce24f66e184b.svg";
export { ForwardRef as ReactComponent };